import { BANNERS_CONFIG_COMMON, BANNERS_TARGET, BANNERS_VISIBILITY } from '@/common/const/banners.const'
import { PROMO_AUTOTOPUP } from '@/plus/const/promo.const'

export const BANNERS_CONFIG = Object.assign({}, BANNERS_CONFIG_COMMON, {
  path: '/images/plus/banners',
  pauseOnHover: true,
  sideControls: false,
  bottomControls: true,
  breakpoints: {
    s: 0,
    m: 768,
    l: 992
  },
  images: {
    pl: {
      items: [
        {
          img: {
            s: 'banner_PnK_allegro_540x220.png',
            m: 'banner_PnK_allegro_700x250.png',
            l: 'banner_PnK_allegro_960x350.png'
          },
          url: '/files/plus/Regulamin_Promocji_Karta_podarunkowa_od_Plusa_na_zakupy_na_Allegro_pl.pdf',
          target: BANNERS_TARGET.blank,
          alt: 'Odbierz 30 zł na zakupy na Allegro.pl',
          dateStart: '2025-08-05 08:00:00',
          dateEnd: '2025-09-14 23:59:59',
          visibility: BANNERS_VISIBILITY.all,
          title: 'Zobacz regulamin - otwiera stronę z plikiem pdf'
        },
        {
          img: {
            s: '540x220.jpg',
            m: '700x290.jpg',
            l: '960x350.jpg'
          },
          url: '/files/plus/1000GB_Lap_najlepsze.pdf',
          target: BANNERS_TARGET.blank,
          alt: '1000 GB extra',
          dateStart: null,
          dateEnd: null,
          visibility: BANNERS_VISIBILITY.all,
          title: 'Zobacz więcej informacji - otwiera stronę z plikiem pdf'
        },
        {
          img: {
            s: 'giga_540x220.jpg',
            m: 'giga_700x290.jpg',
            l: 'giga_960x350.jpg'
          },
          url: '/files/plus/GIGApaka.pdf',
          target: BANNERS_TARGET.blank,
          alt: 'GIGA Paka - Internet bez limitu',
          dateStart: null,
          dateEnd: null,
          visibility: BANNERS_VISIBILITY.all,
          title: 'Zobacz więcej informacji o GIGA Paka - Internet bez limitu - otwiera stronę z plikiem pdf'
        },
        {
          img: {
            s: 'Plus_540x220_04.png',
            m: 'Plus_700x290_04.png',
            l: 'Plus_960x350_04.png'
          },
          url: 'https://doladuj.plus.pl/doladowanie-cykliczne-jak-to-dziala/',
          target: BANNERS_TARGET.blank,
          alt: 'Jeden BLIK i telefon doładowuje się sam',
          dateStart: PROMO_AUTOTOPUP.dateStart,
          dateEnd: PROMO_AUTOTOPUP.dateEnd,
          visibility: BANNERS_VISIBILITY.all,
          title: 'Przejdź do strony doladuj.plus.pl/doladowanie-cykliczne-jak-to-dziala'
        }
      ]
    },
    en: {
      items: []
    },
    uk: {
      items: []
    }
  }
})
